// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__UPUx9","title":"InfoRow_title__3zad6"};